import React from 'react';
import './styles.scss';
import PropTypes from 'prop-types';
import { FaSignOutAlt, FaGlobe } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { signoutRedirect } from '../../services/authService';
import EpButton from '../EpButton';
import useTranslation from '../../hooks/useTranslation';
import { handleToggleModal } from '../EpModal';

const EpUserMenu = ({ id, userName, userEmail }) => {
// Tags do Globalization
  const Language = useTranslation('Language');
  const LogOut = useTranslation('Log out');

  const handleSignOut = () => signoutRedirect();
  const currentUserLanguage = useSelector(state => state.globalization.language);

  return (
    <div
      className="dropdown-menu user-menu__dropdown-content"
      aria-labelledby={id}
    >
      <div className="user-menu__dropdown-content-info">
        <h3 className="user-menu__dropdown-content-info-user">
          {userName}
        </h3>
        <h5 className="user-menu__dropdown-content-info-email">
          {userEmail}
        </h5>
      </div>

      <hr className="user-menu__dropdown-content-divider" />

      <ul className="user-menu__dropdown-content-list">
        <li className="user-menu__dropdown-content-list-item">
          <EpButton
            customClass="user-menu__dropdown-content-list-item-link"
            buttonIcon={<FaGlobe className="btn__icon" />}
            labelText={`${Language} (${currentUserLanguage})`}
            buttonType="link-secondary"
            actionType="button"
            linkFunc={() => handleToggleModal('modal--language')}
            autoClose="true"
          />
        </li>
        <li className="user-menu__dropdown-content-list-item">
          <EpButton
            customClass="user-menu__dropdown-content-list-item-link"
            buttonIcon={<FaSignOutAlt className="btn__icon" />}
            labelText={LogOut}
            buttonType="link-secondary"
            actionType="button"
            linkFunc={() => handleSignOut()}
            autoClose="true"
          />
        </li>
      </ul>
    </div>
  );
};

export default EpUserMenu;

EpUserMenu.propTypes = {
  id: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
  userEmail: PropTypes.string.isRequired,
};
